import {createPaymentColumns, useGetUserDeposits} from '@entities/transaction';
import {ROUTE__DEPOSIT_FULL_INFO} from '@shared/constants';
import {PaymentsTab} from './PaymentsTab';

const columns = createPaymentColumns(ROUTE__DEPOSIT_FULL_INFO, {
  showLocalAmount: true,
});

export const DepositsTab = () => (
  <PaymentsTab
    useGetPayments={useGetUserDeposits}
    columns={columns}
    localStorageKey="userAccountDepositTable"
  />
);
